export default __webpack_public_path__ + "static/banner-how-to-plan-for-your-financial-future-1662f2c57c1286d7426d881a12b0f2be.jpg";